import { render, staticRenderFns } from "./TaxReturnTable.vue?vue&type=template&id=4ac9671c&scoped=true&"
import script from "./TaxReturnTable.vue?vue&type=script&lang=js&"
export * from "./TaxReturnTable.vue?vue&type=script&lang=js&"
import style0 from "./TaxReturnTable.vue?vue&type=style&index=0&id=4ac9671c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac9671c",
  null
  
)

export default component.exports